<template>
  <v-card
    style="max-height: 300px; height: 300px; overflow: scroll; overflow-x: hidden;"
  >
    <v-toolbar card dense color="transparent">
      <v-toolbar-title><h4>Emergency</h4></v-toolbar-title>
      <v-spacer></v-spacer>
      <v-icon class="text--secondary" @click="handleGetAll()">refresh</v-icon>
    </v-toolbar>
    <v-divider></v-divider>
    <v-card-text class="pa-0">
      <template>
        <v-data-table
          :headers="headers"
          :items="items"
          hide-actions
          class="elevation-0 table-striped"
        >
          <template slot="items" slot-scope="props">
            <td class="text-xs-left">
              {{ titleCase(props.item.holder_type) }}
            </td>
            <td class="text-xs-left">
              {{ props.item.sign_out_date ? "Sign Out" : "Sign In" }}
            </td>
            <td class="text-xs-left">
              {{ [props.item.first_name, props.item.last_name].join(" ") }}
            </td>
            <td class="text-xs-left">
              {{
                props.item.sign_in_date
                  ? props.item.sign_in_time
                  : props.item.sign_out_time
              }}
            </td>
          </template>
        </v-data-table>
      </template>
      <v-divider></v-divider>
    </v-card-text>
  </v-card>
</template>

<script>
import APIAttendance from "@/mixins/APIAttendance";
export default {
  mixins: [APIAttendance],
  props: {
    type: {
      format: String,
      default: "Students"
    }
  },
  data() {
    return {
      categories: ["Students", "Staff", "Visitor", "Contractor"],
      headers: [
        { text: "Type", value: "progress", sortable: false },
        { text: "Sign Type", value: "status", sortable: false },
        { text: "Name", value: "deadline", sortable: false },
        { text: "Date/Time", value: "", sortable: false }
      ],
      items: [],
      colors: {
        processing: "blue",
        sent: "red",
        delivered: "green"
      }
    };
  },
  created() {
    this.handleGetAll();
  },
  computed: {
    randomColor() {
      let item = Math.floor(Math.random() * this.colors.length);
      return this.colors[item];
    }
  },
  methods: {
    getColorByStatus(status) {
      return this.colors[status];
    },
    handleGetAll: async function() {
      this.items = [];
      try {
        let students = await this.emergencyList("student");
        let staff = await this.emergencyList("staff");
        let visitors = await this.emergencyList("visitor");
        let constractors = await this.emergencyList("contractor");

        let list = []
          .concat(students)
          .concat(staff)
          .concat(visitors)
          .concat(constractors);
        this.items = list;
        this.backup = list;
        // this.processList();
      } catch (error) {
        this.$toast.error("Failed to fetch records!", "Error", {
          position: "topCenter"
        });
      }
    }
  }
};
</script>
